import { type QueryKey, useQueryClient } from '@tanstack/react-query';
import { type AxiosResponse } from 'axios';

export const useGetQuery = <T>(queryKey: QueryKey): AxiosResponse<T> | undefined => {
  const queryCache = useQueryClient();
  const data = queryCache.getQueryData<AxiosResponse<T>>(queryKey);
  return data;
};
